const MOBILE_BREAKPOINT = 767;
const INITIALIZED_ATTR = 'data-complementary-swiper-initialized';

function shouldEnableSwiper() {
  return typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;
}

function getContainers(root = document) {
  if (!root || typeof root.querySelectorAll !== 'function') return [];
  return Array.from(root.querySelectorAll('.complementary-products-container swiper-container'));
}

function updateContainerState(swiperContainer, enableSwiper) {
  if (!swiperContainer) return;

  const ensureInitialized = () => {
    if (swiperContainer.swiper && swiperContainer.swiper.destroyed && typeof swiperContainer.initialize === 'function') {
      swiperContainer.initialize();
      return;
    }

    if (!swiperContainer.swiper && typeof swiperContainer.initialize === 'function') {
      swiperContainer.initialize();
    }
  };

  if (enableSwiper) {
    swiperContainer.setAttribute('init', 'true');
    swiperContainer.classList.remove('desktop');

    ensureInitialized();

    const swiper = swiperContainer.swiper;
    if (swiper && !swiper.destroyed) {
      swiper.allowTouchMove = true;
      if (typeof swiper.enable === 'function') {
        swiper.enable();
      }
      if (typeof swiper.update === 'function') {
        swiper.update();
      }
    }
    return;
  }

  swiperContainer.setAttribute('init', 'true');
  swiperContainer.classList.add('desktop');

  ensureInitialized();

  const swiper = swiperContainer.swiper;
  if (swiper && !swiper.destroyed) {
    if (typeof swiper.slideTo === 'function') {
      swiper.slideTo(0, 0, false);
    }
    swiper.allowTouchMove = false;
    if (typeof swiper.update === 'function') {
      swiper.update();
    }
  }
}

function applyState(root = document) {
  const enableSwiper = shouldEnableSwiper();
  getContainers(root).forEach((container) => updateContainerState(container, enableSwiper));
}

function onDomReady(callback) {
  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }

  callback();
}

function whenSwiperReady(callback) {
  if (typeof window === 'undefined' || typeof callback !== 'function') {
    if (typeof callback === 'function') callback();
    return;
  }

  if (!window.customElements || window.customElements.get('swiper-container')) {
    callback();
    return;
  }

  if (typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('swiper-container')
      .then(callback)
      .catch(() => callback());
    return;
  }

  callback();
}

(function initComplementaryProductsSwiper() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  if (document.documentElement.hasAttribute(INITIALIZED_ATTR)) {
    applyState(document);
    return;
  }

  document.documentElement.setAttribute(INITIALIZED_ATTR, 'true');

  let resizeTimeout;
  const handleResize = () => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    resizeTimeout = setTimeout(() => applyState(document), 100);
  };

  window.addEventListener('resize', handleResize, { passive: true });

  document.addEventListener('shopify:section:load', (event) => {
    whenSwiperReady(() => applyState(event?.target || document));
  });

  onDomReady(() => {
    // Apply once immediately so desktop stacks are visible, then re-apply after upgrade.
    applyState(document);
    whenSwiperReady(() => applyState(document));
  });
})();
